import moment from "moment";
import Vue from "vue";
import {
    CATEGORIA_UNIDADE,
    SITUACAO,
    SITUACAO_SOLICITACAO,
    SITUACAO_SOLICITACAO_ANTIGA,
    TIPO_ATENDIMENTO,
    TIPO_CONSULTA
} from "../constants";

moment.locale("pt-br");

Vue.filter("tipoAtendimento", function(value) {
    switch (value) {
        case TIPO_ATENDIMENTO.INDIVIDUAL:
            return 'Individual';
        case TIPO_ATENDIMENTO.AGRUPADO:
            return 'Agrupado';
    }
});

Vue.filter("tipoConsulta", function(value) {
    switch (value) {
        case TIPO_CONSULTA.PRIMEIRA:
            return '1º';
        case TIPO_CONSULTA.RETORNO:
            return 'R';
        case TIPO_CONSULTA.LOCAL:
            return 'L';
    }
});

Vue.filter('codigoNomeProcedimento', function(value) {
    return value.codigo + " - " + value.nome;
});

Vue.filter('diasDaData', function(value) {
    let dias = Math.round((Date.now() - moment(value)) / (1000 * 60 * 60 * 24));
    switch (dias) {
        case 0:
            return "Hoje";
        case 1:
            return dias + " dia";
        default:
            return dias + " dias";
    }
});

Vue.filter('horaFormatada', function(value) {
    return value.substr(0, 5);
});

Vue.filter("dataFormatada", function(value) {
    if (value) {
        return moment(value).format("L");
    }
});

Vue.filter("diaDaSemana", function(value) {
    if (value) {
        return moment(value).format("dddd");
    }
});

Vue.filter("mesPorExtenso", function(value) {
    if (value) {
        return moment(value).format("MMMM");
    }
});

Vue.filter("formatarCodigo", function(value) {
    if (value) {
        return value.toString().padStart(10, '0')
    }
});

Vue.filter("dataHoraFormatada", function(value) {
    if (value) {
        return moment(value).format("lll");
    }
});

Vue.filter("dataFormatadaHora", function(value) {
    if (value) {
        return moment(value).format("L LT");
    }
});

Vue.filter("dataFormatadaHoraCompleta", function(value) {
    if (value) {
        return moment(value).format("L LTS");
    }
});

Vue.filter("uppercase", function(value) {
    if (value) {
        return value.toUpperCase();
    }
});

Vue.filter("dinheiro", function(value) {
    if (value) {
        return "R$ " + value;
    }
});

Vue.filter("inteiro", function(value) {
    let valor = "";
    if (value != null) {
        valor = parseInt(value);
    }
    return valor;
});

Vue.filter("tipoContrato", function(value) {
    if (value == 0) {
        return 'Solicitante';
    } else if (value == 1) {
        return 'Prestador';
    }
});

Vue.filter("tipoAtendimento", function(value) {
    if (value == 0) {
        return 'Individual';
    } else if (value == 1) {
        return 'Agrupado';
    }
});

Vue.filter("sexo", function(value) {
    if (value == 0) {
        return 'Ambos';
    } else if (value == 1) {
        return 'Masculino';
    } else if (value == 2) {
        return 'Feminino';
    }
});

Vue.filter("tipoAgrupamento", function(value) {
    switch (value) {
        case 0:
            return 'BIOQUÍMICA';
        case 1:
            return 'OFTALMOLOGIA';
    }
});

Vue.filter("categoriaUnidade", function(value) {
    switch (value) {
        case CATEGORIA_UNIDADE.PUBLICA_LOCAL:
            return 'Pública (Local)';
        case CATEGORIA_UNIDADE.PACTUADA:
            return 'Município Pactuado';
        case CATEGORIA_UNIDADE.PRIVADA:
            return 'Privada';
    }
});

Vue.filter("situacaoSolicitacao", function(value) {
    switch (value) {
        case SITUACAO_SOLICITACAO.MARCADA:
            return "Marcada";
        case SITUACAO_SOLICITACAO.EM_REGULACAO:
            return "Em regulação";
        case SITUACAO_SOLICITACAO.REGULADA:
            return "Regulada";
        case SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE:
            return "Informação pendente";
        case SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL:
            return "Informação adicional";
        case SITUACAO_SOLICITACAO.CONFIRMADA:
            return "Confirmada";
        case SITUACAO_SOLICITACAO.CANCELADA:
            return "Cancelada";
        case SITUACAO_SOLICITACAO.FALTA:
            return "Falta";
        case SITUACAO_SOLICITACAO.REALIZADA:
            return "Realizada";
        case SITUACAO_SOLICITACAO.NEGATIVADA:
            return "Negativada";
    }
});

Vue.filter("situacaoSolicitacaoAntiga", function(value) {
    switch (value) {
        case SITUACAO_SOLICITACAO_ANTIGA.EM_ANALISE:
            return 'EM ANALISE';
        case SITUACAO_SOLICITACAO_ANTIGA.APROVADA:
            return 'APROVADA';
        case SITUACAO_SOLICITACAO_ANTIGA.CONFIRMADA:
            return 'CONFIRMADA';
        case SITUACAO_SOLICITACAO_ANTIGA.NEGADA:
            return 'NEGADA';
        case SITUACAO_SOLICITACAO_ANTIGA.EM_PERICIA:
            return 'EM PERÍCIA';
        case SITUACAO_SOLICITACAO_ANTIGA.CANCELADA:
            return 'CANCELADA';
        case SITUACAO_SOLICITACAO_ANTIGA.REALIZADA:
            return 'REALIZADA';
        case SITUACAO_SOLICITACAO_ANTIGA.FALTA:
            return 'FALTA';
        case SITUACAO_SOLICITACAO_ANTIGA.EM_SUPERVISAO:
            return 'EM SUPERVISÃO';
        case SITUACAO_SOLICITACAO_ANTIGA.SUPERVISIONADO:
            return 'SUPERVISIONADO';
        case SITUACAO_SOLICITACAO_ANTIGA.EM_EXTRAPOLACAO:
            return 'EM EXTRAPOLACAO';
        case SITUACAO_SOLICITACAO_ANTIGA.TFD:
            return 'TFD';
        case SITUACAO_SOLICITACAO_ANTIGA.FALTA_AUTOMATICA:
            return 'FALTA AUTOMÁTICA';
    }
});

Vue.filter("situacaoSolicitacaoAntigaColor", function(value) {
    switch (value) {
        case SITUACAO_SOLICITACAO_ANTIGA.EM_ANALISE:
            return 'em_analise'; //
        case SITUACAO_SOLICITACAO_ANTIGA.APROVADA:
            return 'aprovada'; //
        case SITUACAO_SOLICITACAO_ANTIGA.CONFIRMADA:
            return 'confirmada'; //
        case SITUACAO_SOLICITACAO_ANTIGA.NEGADA:
            return 'negada'; //
        case SITUACAO_SOLICITACAO_ANTIGA.EM_PERICIA:
            return 'em_pericia'; //
        case SITUACAO_SOLICITACAO_ANTIGA.CANCELADA:
            return 'cancelada'; //
        case SITUACAO_SOLICITACAO_ANTIGA.REALIZADA:
            return 'realizada'; //
        case SITUACAO_SOLICITACAO_ANTIGA.FALTA:
            return 'falta'; //
        case SITUACAO_SOLICITACAO_ANTIGA.EM_SUPERVISAO:
            return 'em_supervisao'; //
        case SITUACAO_SOLICITACAO_ANTIGA.SUPERVISIONADO:
            return 'supervisionado'; //
        case SITUACAO_SOLICITACAO_ANTIGA.EM_EXTRAPOLACAO:
            return 'em_extrapolacao'; //
        case SITUACAO_SOLICITACAO_ANTIGA.TFD:
            return 'tfd'; //
        case SITUACAO_SOLICITACAO_ANTIGA.FALTA_AUTOMATICA:
            return 'falta_automatica'; //
    }
});

Vue.filter("situacaoSolicitacaoColor", function(value) {
    switch (value) {
        case SITUACAO_SOLICITACAO.MARCADA:
            return "marcada";
        case SITUACAO_SOLICITACAO.EM_REGULACAO:
            return "regulacao";
        case SITUACAO_SOLICITACAO.REGULADA:
            return "regulada";
        case SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE:
            return "pendente";
        case SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL:
            return "adicional";
        case SITUACAO_SOLICITACAO.CONFIRMADA:
            return "confirmada";
        case SITUACAO_SOLICITACAO.CANCELADA:
            return "cancelada";
        case SITUACAO_SOLICITACAO.FALTA:
            return "falta";
        case SITUACAO_SOLICITACAO.REALIZADA:
            return "realizada";
        case SITUACAO_SOLICITACAO.NEGATIVADA:
            return "negativada";
    }
});

Vue.filter("situacao", function(value) {
    switch (value) {
        case SITUACAO.INATIVA:
            return 'Inativo (a)';
        case SITUACAO.ATIVA:
            return 'Ativo (a)';
    }
});

Vue.filter("competencia", function(value) {
    if (value) {
        return moment(value).format("MM/YYYY");
    }
});

Vue.filter("idade", function(value) {
    if (value) {
        var hoje = new Date();
        var nascimento = new Date(value);
        var diferencaAnos = hoje.getFullYear() - nascimento.getFullYear();
        if (new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()) < new Date(hoje.getFullYear(), nascimento.getMonth(), nascimento.getDate())) {
            diferencaAnos--;
        }

        return diferencaAnos > 1 ? diferencaAnos + " anos" : diferencaAnos + " ano";
    }
});

Vue.filter("numberFormat", function(number, decimals, decPoint, thousandsSep) {
    if (!number && number != 0) {
        return '';
    }
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number;
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
    var s = '';
    var toFixedFix = function(n, prec) {
        var k = Math.pow(10, prec);
        return '' + Math.round(n * k) / k;
    };

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return 'R$ ' + s.join(dec);
});

Vue.filter("intervaloIdade", function(idadesArray) {
    var idadeMinima = idadesArray[0];
    var idadeMaxima = idadesArray[1];
    if (idadeMinima === null && idadeMaxima === null) {
        return '-';
    } else if (idadeMinima !== null && idadeMaxima === null) {
        return '> ' + idadeMinima + ' anos';
    } else if (idadeMinima === null && idadeMaxima !== null) {
        return '< ' + idadeMaxima + ' anos';
    } else {
        return idadeMinima + ' a ' + idadeMaxima + ' anos';
    }
});

Vue.filter("intervaloHoras", function(horasArray) {
    var horaInicial = horasArray[0];
    var horaFinal = horasArray[1];
    return horaInicial.substr(0, 5) + ' às ' + horaFinal.substr(0, 5);
});

Vue.filter("quantidadeAtendimentos", function(quantidadeArray) {
    var quantidadeOriginal = quantidadeArray[0];
    var quantidadeDisponivel = quantidadeArray[1];
    return quantidadeOriginal + " | " + quantidadeDisponivel;
});

Vue.filter("zero", function(value) {
    if (!value) {
        return '0'
    } else {
        return value
    }
});

Vue.filter("dia", function(value) {
    switch (value) {
        case 0:
            return 'Domingo'
        case 1:
            return 'Segunda-feira'
        case 2:
            return 'Terça-feira'
        case 3:
            return 'Quarta-feira'
        case 4:
            return 'Quinta-feira'
        case 5:
            return 'Sexta-feira'
        case 6:
            return 'Sábado'
    }
});


// WEBPACK FOOTER //
// ./src/filters/index.js